<div class="d-flex flex-column w-100">
  <span class="menus-back-btn" (click)="goBack()">
    <i class="pi pi-arrow-left me-4"></i>{{'MENU.BACK' | translate}}</span>
  <p-progressSpinner class="w-100 text-center pos_menu_details_spinner" *ngIf="spinner"></p-progressSpinner>
</div>
<div class="div_menu_details" *ngIf="!spinner">
  <div class="menu-details-header d-flex flex-row align-items-center justify-content-between">
    <div class="img-container d-flex align-items-center">
      <img class="menu-img" [src]="imagePath" alt="division-img">
      <label class="ellipsis menu-name" title="{{menuModel.name}}">{{menuModel.name}}</label>
    </div>
    <span class="menu-created">{{'MENU.CREATED' | translate}}: {{menuModel.createDate | date: 'dd-MM-YYYY'}}</span>
  </div>
  <div class="menu-details-wrapper">
    <div class="menu-details-container w-100" style="overflow: auto;box-sizing: border-box;max-height: 100%;">
      <div *ngFor="let category of menuModel.venueMenuCategories">
        <span class="category-name">{{category.name}}</span>
        <ul>
          <li class="d-flex" *ngFor="let menuItem of category.venueMenuItems">
            <span class='name'>
              <span class="ellipsis" title="{{menuItem.name}}">{{menuItem.name}}</span>
            </span>
            <span class="price">{{menuItem.price}} {{currency}}</span>
          </li>
        </ul>
        <div *ngFor="let subcategory of category.childVenueMenuCategories">
          <span class="subcategory-name">{{subcategory.name}}</span>
          <ul>
            <li class="d-flex" *ngFor="let menuItem of subcategory.venueMenuItems">
              <span class='name'>
                  <span class="ellipsis" title="{{menuItem.name}}">{{menuItem.name}}</span>
              </span>
              <span class="price">{{menuItem.price}} {{currency}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
